import {useContext, useEffect } from "react";
import Joyride from "react-joyride";
import cafgu from "../../../../../assets/images/core/cafgu.svg"
import { ToolContext } from "../../../../context/ToolContext";
import { ExploreTourToolTip } from "../ExploreTourToolTip";
import { VM } from "../../../../VM";

export const OnboardingDesktop = ({ pathname, end, start}) => {

    const {personalization_state, tool_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state
    const {__SESSION} = tool_state

    const role = __SESSION.data.uaccess[0].role_name
    const view = VM()

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, onboarding:true}))
    }

    useEffect(() => {
        start("dashboard", "onboarding-desktop", startTour)
        //eslint-disable-next-line
    }, []);
    

    const steps = [
            {
                placement: "center",
                disableBeacon: true,
                target: "body",
                // title: <Typography>Welcome to Point of Sale!</Typography>
            },
            {
                content: "Monitor your sales and branch performance",
                placement: "right",
                target: "#onboarding-dashboard",
                title: "Dashboard",

            },
            {
                content: "Create and manage your branches and products",
                placement: "right",
                target: "#onboarding-setup",
                path: '/setup/branch/list',
                title: "Setup"
            },
            {
                content: "Generate accurate sales reports based on given time range",
                placement: "right",
                target: "#onboarding-reports",
                title: "Reports",
                path: '/reports/branch-product',
            },
                    {
                content: "Explore different tools to grow your business or your own career",
                placement: "right",
                target: "#onboarding-tool-categories",
                title: "Tool Categories",
                path: "/tool-categories/subscribed"
            },
            {
                content: "View different tutorials and tool details",
                placement: "right",
                target: "#onboarding-help",
                title: "Help"
            },
            {
                content: "Reach with us for your feedback and concerns",
                placement: "right",
                target: "#onboarding-support",
                title: "Support"
            },
            {
                content: "Click to download and install POS in your device",
                placement: "bottom",
                target: "#onboarding-download",
                title: "Download"
            },
            {
                content: "A quick-access that provides shortcuts to all available benefits tools, helping you find and use key features faster.",
                placement: "bottom",
                target: "#onboarding-mytools",
                title: "My Tools"
            },
            {
                content: "Manage your app settings, preferences, and personal details while exploring additional features tailored to your experience.",
                placement: "bottom",
                target: "#onboarding-profile",
                title: "Profile"
            },
        ]

    const stepsRegularUser = [
            {
                placement: "center",
                disableBeacon: true,
                target: "body",
                // title: <Typography>Welcome to Point of Sale!</Typography>
            },
            {
                content: "Allows you to select branch and create order",
                placement: "right",
                target: "#onboarding-regular-user-home",
                title: "Home",

            },
            {
                content: "To save end of day report, you must go to reports feature",
                placement: "right",
                target: "#onboarding-regular-user-reports",
                path: '/setup/branch/list',
                title: "End of Day Report"
            },
            {
                content: "Tool Categories holds different tools that can help you grow",
                placement: "right",
                target: "#onboarding-regular-user-tool-categories",
                title: "Tool Categories",
                path: '/reports/branch-product',
            },
                    {
                content: "This holds your notifications",
                placement: "right",
                target: "#onboarding-regular-user-notifications",
                title: "Notifications",
                path: "/tool-categories/subscribed"
            },
            {
                content: "Tap here to view POFSIS tools",
                placement: "right",
                target: "#onboarding-regular-user-mytools",
                title: "My Tools"
            },
        ]


    const CustomTooltip = ({ step, primaryProps, skipProps, backProps, tooltipProps, size, index}) => (
        <ExploreTourToolTip featureName="dashboard" p_name="onboarding-desktop" role={role} view={view} end={end} image={cafgu} step={step} primaryProps={primaryProps} skipProps={skipProps} backProps={backProps} tooltipProps={tooltipProps} size={size} index={index} setter={()=>{walkthrough.set((prev)=>({...prev, onboarding: false}))}}/>
    );  

    return (
        <Joyride
            continuous
            callback={({ status}) => {
                if (status === 'finished') {
                    end("dashboard", "onboarding-desktop")
                    // startHere.set((prev)=>({...prev, modal: true}))
                }
            }}
            disableOverlayClose={true}
            run={walkthrough.data.onboarding && window.location.pathname === pathname}
            steps={view === "" ? steps : stepsRegularUser}
            hideCloseButton
            scrollToFirstStep
            showSkipButton={false}
            showProgress
            tooltipComponent={CustomTooltip}
            // spotlightClicks={true}
        />
    );
}
